import { getAuth, RecaptchaVerifier } from "firebase/auth";

const generateRecaptcha = () => { // TODO: move to utils/firebase utils
  const auth = getAuth();
  window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha', {
    callback: (response: any) => {
      // reCAPTCHA solved, allow signInWithPhoneNumber.
      // ...
    }
  });
}

export default generateRecaptcha;